<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="accountModalLabel" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow">
                <!-- ヘッダー -->
                <div class="modal-header bg-success bg-gradient text-white border-bottom-0 pb-2">
                    <h5 class="modal-title fw-bold">
                        <i :class="account.id ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-plus-circle'" class="me-2"></i>
                        {{ account.id ? '勘定科目編集' : '新規勘定科目作成' }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- ボディ -->
                <div class="modal-body px-4 py-3">
                    <!-- グローバルエラー -->
                    <div v-if="error.global" class="alert alert-danger d-flex align-items-start mb-3">
                        <i class="fa-solid fa-circle-exclamation me-2 mt-1"></i>
                        <span>{{ error.global }}</span>
                    </div>

                    <!-- 勘定科目名 -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-tag me-1"></i>勘定科目名
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-file-invoice text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control form-control-lg border-start-0"
                                v-model="account.name"
                                :class="{'is-invalid': error.name}"
                                placeholder="例: 売上高"
                                required
                                data-error-key="name"
                            >
                        </div>
                        <div v-if="error.name" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.name }}
                        </div>
                    </div>

                    <!-- ふりがな -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-language me-1"></i>ふりがな
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-font text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control border-start-0"
                                v-model="account.kana"
                                :class="{'is-invalid': error.kana}"
                                placeholder="例: うりあげだか"
                                required
                                data-error-key="kana"
                            >
                        </div>
                        <div v-if="error.kana" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.kana }}
                        </div>
                    </div>

                    <!-- 勘定科目コード -->
                    <div class="mb-3">
                        <label class="form-label text-muted small mb-2">
                            <i class="fa-solid fa-barcode me-1"></i>勘定科目コード
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="fa-solid fa-hashtag text-muted"></i>
                            </span>
                            <input
                                type="text"
                                class="form-control border-start-0"
                                v-model="account.code"
                                :class="{'is-invalid': error.code}"
                                placeholder="例: 4000"
                                required
                                data-error-key="code"
                            >
                        </div>
                        <div v-if="error.code" class="text-danger small mt-1">
                            <i class="fa-solid fa-circle-info me-1"></i>{{ error.code }}
                        </div>
                    </div>
                </div>

                <!-- フッター -->
                <div class="modal-footer border-top-0 pt-2 px-4">
                    <button type="button" class="btn btn-outline-secondary" @click="close()">
                        <i class="fa-solid fa-xmark me-2"></i>キャンセル
                    </button>
                    <button type="button" class="btn btn-primary" @click="save()">
                        <i class="fa-solid fa-floppy-disk me-2"></i>保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccountTitlesEditor',
    props: {
        id: {
            default: 'account-titles-editor'
        },
        account_title_id: {
            default: null,
        }
    },
    data() {
        return {
            account: {},
            error: {},
        };
    },
    methods: {
        close() {
            this.$emit('close', this.id);
        },
        reload() {
            if (!this.account_title_id) {
                this.account = {};
                return;
            }
            axios.get(`/api/master/account-title?id=${this.account_title_id}`).then(res => {
                this.account = res.data;
            }).catch(err => {Alert.err(err)})
        },
        validate() {
            this.error = {};
            if (!this.account.code) this.error.code = '勘定科目コードは必須です。';
            if (!this.account.name) this.error.name = '勘定科目名は必須です。';
            if (!this.account.kana) this.error.kana = 'ふりがなは必須です。';
            return Object.keys(this.error).length === 0;
        },
        save() {
            if (!this.validate()) { return; }
            axios.post('/api/master/account-titles', this.account).then(() => {
                Alert.msg("保存しました。");
                this.$emit('saved');
                this.close();
            }).catch(err => {
                Alert.err(err);
            });
        }
    },
    mounted() {
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    }
}
</script>
